var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name !== 'page-not-found' && _vm.$route.name !== 'error' && _vm.organizationStringified)?_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.organizationStringified)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }